import { render } from "./AddShippingAddressDialog.vue?vue&type=template&id=3f403363&ts=true"
import script from "./AddShippingAddressDialog.vue?vue&type=script&lang=ts"
export * from "./AddShippingAddressDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__